import { NEWSFEED_SEEN_STORAGE_KEY } from '@/constants';
import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export const initialState: Record<string, string[]> =
	typeof window !== 'undefined'
		? JSON.parse(localStorage.getItem(NEWSFEED_SEEN_STORAGE_KEY) || 'null') || {}
		: {};

export const newsfeedSlice = createSlice({
	name: 'newsfeed',
	initialState,
	reducers: {
		setSeenArticleIds: (
			state: Record<string, string[]>,
			action: { payload: { eventId: string; articleIds: string[] } }
		) => {
			const { eventId, articleIds } = action.payload;
			const existing = state[eventId] || [];
			state[eventId] = Array.from(new Set([...existing, ...articleIds]));
			localStorage.setItem(NEWSFEED_SEEN_STORAGE_KEY, JSON.stringify(state));
		},
	},
});

export const { setSeenArticleIds } = newsfeedSlice.actions;

export const useSeenNewsfeedArticleIdsSelector = (eventId?: string) =>
	useSelector((state: any) => (eventId ? (state.newsfeed?.[eventId] ?? []) : []));
